import { useEffect, useRef, type ComponentRef } from 'react';
import { Calendar, type CalendarChangeEvent } from '@ics-portal/guardian';

export interface DateDropdownProps {
    onSelect: (iso: string) => void;
}

export function DateDropdown(props: DateDropdownProps): JSX.Element {
    const { onSelect } = props;
    const ref = useRef<ComponentRef<typeof Calendar>>(null);
    useEffect(() => {
        ref.current?.focus();
    }, []);
    return (
        <div className="ics-table__search-dropdown ics-table__search-date">
            <Calendar
                ref={ref}
                inline
                showIcon={false}
                aria-label="Pick a date"
                onChange={(e: CalendarChangeEvent) => {
                    if (e.value instanceof Date)
                        onSelect(e.value.toISOString().slice(0, 10));
                }}
            />
        </div>
    );
}
